const MISCELLANEOUS = {
    pageDataAid: "securitySettings",
    pageTitle: {
        text:"Security settings",
        dataAid: 'securitySettings'
    },
}


const CONTENT = {
    biometricRow: {
        rowDataAid:"biometrics",
        title: {
            text: "Biometrics",
            dataAid: 'title'
        },
        toggleDataAid: 'biometric',
        errorTextBioMetric:'Biometrics access not available',
        successBioMetricText: (isBiometric) =>`Biometrics ${isBiometric ? 'enabled' : 'disabled'}`,
    },
    resetPinRow: {
        rowDataAid:"resetPin",
        title: {
            // text is dynamic (generated in screen itself)
            dataAid: "title"
        },
        rightIconDataAid: "right"
    }
}

const SECURITY_SETTINGS = {
    ...MISCELLANEOUS,
    CONTENT
}

export default  SECURITY_SETTINGS;

